import React, { useState } from 'react';
import FeedbackForm from './FeedbackForm';
import './FeedbackButton.css';

const FeedbackButton = ({ position = 'bottom-right', variant = 'floating' }) => {
  const [showForm, setShowForm] = useState(false);

  const handleOpenForm = () => {
    setShowForm(true);
  };

  const handleCloseForm = () => {
    setShowForm(false);
  };

  const handleSubmitSuccess = (feedback) => {
    console.log('Feedback submitted successfully:', feedback);
    // You can add additional success handling here
  };

  if (variant === 'inline') {
    return (
      <>
        <button 
          className="feedback-button-inline"
          onClick={handleOpenForm}
        >
          <span className="feedback-icon">💬</span>
          Give Feedback
        </button>
        {showForm && (
          <FeedbackForm 
            onClose={handleCloseForm}
            onSubmit={handleSubmitSuccess}
          />
        )}
      </>
    );
  }

  return (
    <>
      <button 
        className={`feedback-button-floating ${position}`}
        onClick={handleOpenForm}
        title="Give us feedback"
      >
        <span className="feedback-icon">💬</span>
        <span className="feedback-text">Feedback</span>
      </button>
      {showForm && (
        <FeedbackForm 
          onClose={handleCloseForm}
          onSubmit={handleSubmitSuccess}
        />
      )}
    </>
  );
};

export default FeedbackButton;